// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxInput_checkbox__3rqEs","checked":"CheckboxInput_checked__2uGZJ"};